import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { DialogHelper } from "../core/util/dialogHelper";
import { BasicDialog } from "../statistics/reactcomponent";
import { ComponentHelper } from "../core/util/componentHelper";
import { ComboBox, ComboBoxProps } from "../core/components/comboBox";
import { Grid } from "../core/components/grid";
import { Config } from "../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { TextBox } from "../core/components/textBox";
import { FieldInstance } from "../core/components/field";
import { FAIcon } from "../core/components/faIcon";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";


export default class ServerTemplateFile extends React.Component<any, any> {
    common = new AppHelper();
    setTabTitle = this.props.doNotUpdateBrowserTitle;
    translations: StringKeyDictionary<string> = null;
    private _uploadInputRef = null;
    private tree: JQuery<HTMLElement> = null;
    private treeData: Array<FileNodeElement> = [];
    private _uploadRef: kendo.ui.Upload = null;
    uploadEnabled = false;
    uploadOptions: kendo.ui.UploadOptions = { multiple: false };
    private _updateFile = null;
    private fileGridOptions;
    private resourceGridOptions;
    private _componentFactory = ComponentHelper.createFactory();
    private _folderName: string = "";
    private _fileRemark: string = "";
    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.translations = this.props.context.translations ;
        this.fileGridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: false,
            scrollable: true,
            dataSource: {
                aggregate: [
                    { field: "Filesize", aggregate: "sum" }
                ]                             
            },
            columns: [
                {
                    field: "Name",
                    title: this.translations["Field.Ressource.name"],
                    width: 95
                },
                {
                    field: "Remark",
                    title: this.translations["WebSMS.DataExchangeModule.File.Remark"],
                    width: 65
                },
                {
                    field: "Filesize",
                    title: this.translations["WebSMS.DataExchangeModule.File.FileSize"],
                    width: 65,
                    footerTemplate: " #:data.Filesize.sum#"
                },
                {
                    field: "Deleted",
                    title: this.translations["WebSMS.DataExchangeModule.File.Status"],
                    template: "# if(Deleted) {#<div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times' title='"
                        + this.translations["WebSMS.DataExchangeModule.File.FileContentDeleted"]
                        + "'></i></div>#}else{#<div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check' title='"
                        + this.translations["WebSMS.UpdateApplication.UploadProcess"] +
                        "'></i></div>#}#",
                    width: 65      }
            ]
        }      
        this.state = {
            showDialoge: false,
            fileGridData: this.props.entity.FileNames,
            invalidFilePath: false,
            deleteEnable:true
        };
        
    }

    private uploadeFileInDB = (file) => {
        const formData = new FormData();
        for (let key in file) {
            formData.append(key, file[key]);
        }
        formData.append("path", this._folderName);
        formData.append("fileremark", this._fileRemark);
        if (file.file.size <= this.props.entity.MaxRequestLength) {
            HTTPService.post<JsonResultClass>("ServerJob/SaveFileInDataBase", formData).then(result => {
                if (result.Code == 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                    this.updateFileGrid();
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
        } else {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.DataExchangeModule.FileSizeToLarge"));
            NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.DataExchangeModule.File.FileSizeIncrease"));
        }
        


    }
    private _doOnSelect = (kendoEvent: kendo.ui.UploadSelectEvent) => {
        const file = kendoEvent.files[0].rawFile;
        const validUpload = Helper.hasValue(file);
        const isStd = kendoEvent.sender["name"] === "updateFile";
        const sendData: StringKeyDictionary<any> = {
            name: file.name
        };
        if (this.props.entity.Jobid != null) {
            sendData.Jobid = this.props.entity.Jobid;
        }
        sendData.file = file;

        $(".k-upload-action.k-button.k-button-bare", $("#" + ("document-upload"))).trigger("click");

        if (validUpload) {
            this.uploadEnabled = true;
            if (isStd) {
                this._updateFile = file;
            }
        } else {
            if (isStd) {
                this._updateFile = null;
            }
            this.uploadEnabled = Helper.hasValue(this._updateFile);
            NotificationHelper.showWarningMessage(this.translations["validFile"]);
            kendoEvent.files.pop();
            kendoEvent.preventDefault();
            $(".k-upload-action.k-button.k-button-bare", $("#" + ("document-upload"))).trigger("click");
        }
        this.setState({ showDialoge: true, sendData: sendData });
    }
    componentDidMount() {

        this.uploadOptions.select = this._doOnSelect;
        this.uploadOptions.remove = (kendoEvent) => {
            const isStd = kendoEvent.sender["name"] === "updateFile";

            if (isStd) {
                this._updateFile = null;
            }
            this.uploadEnabled = Helper.hasValue(this._updateFile);

            this.setState({});
        }
        this._uploadRef = $(this._uploadInputRef).kendoUpload(this.uploadOptions).data("kendoUpload");
    }
    private onCompChange = (field, value) => {
        if (field.model === "foldername") {
            var match = value.match(/[|/~"?<>|*]/);
            if (match === null) {
                this._folderName = value;
            } else {
                this._folderName = value;
                this.setState({ invalidFilePath: true });
            }
        }
        else if (field.model === "fileremark") {
            this._fileRemark = value;
        }
        this.setState({});
    }


    renderDialog = () => {
        const comboProps = this._componentFactory.getDefaultComboBoxProps() as ComboBoxProps;
        comboProps.commandManager = this.props.commandManager;
        comboProps.onChange = this.onCompChange;
        comboProps.onDataLoaded = () => { };
        comboProps.value = this._folderName;
        comboProps.disabled = false;
        comboProps.field.required = false
        comboProps.field.model = "foldername";
        comboProps.field.name = "Test";
        comboProps.dataSource = [{ name: "Tools", value: "Tools" }, { name: "Reports", value: "Reports" }];
        comboProps.field.dataTextField = "name";
        comboProps.field.dataValueField = "value";

        const textBoxProps = this._componentFactory.getDefaultTextBoxProps();
        textBoxProps.field.readOnly = true;
        textBoxProps.disabled = false;
        textBoxProps.value = this._fileRemark;
        textBoxProps.onChange = this.onCompChange;
        textBoxProps.field.triggerOnChange = false;
        textBoxProps.field.model = "fileremark";
        if (this.state.showDialoge) {
            return <BasicDialog width="500px" title={this.translations["WebSMS.DataExchangeModule.File.UploadFile"]} onSave={() => { if (!this.state.invalidFilePath) { this.uploadeFileInDB(this.state.sendData) } }} onClose={() => { this.onCloseDialoge() }}>
                <FieldInstance label={this.translations["WebSMS.DataExchangeModule.File.Foldername"]}>
                    <ComboBox {...comboProps} />
                </FieldInstance>
                {this.getWarningText()}
                <FieldInstance label={this.translations["WebSMS.DataExchangeModule.File.Remark"]}>
                    <TextBox{...textBoxProps} />
                </FieldInstance>
            </BasicDialog>
        }
        return null;
    }
    private onCloseDialoge = () => {
        this._folderName = "";
        this._fileRemark = "";
        this.setState({ showDialoge: false, invalidFilePath: false });
    }
    getWarningText = () => {
        let divText = this.translations["WebSMS.DataExchangeModule.File.NoAdditionalChar"]
        return (this.state.invalidFilePath) ? <div style={{
            marginTop: "5px",
            backgroundColor: "#f8e8e8",
            borderLeftColor: "red",
            borderLeftWidth: "4px",
            padding: "3px", borderLeftStyle: "solid",
            color: "#f05050",
            display: "flex"
        }}> <FAIcon name="exclamation-triangle" sameWidth={true} /><div style={{ marginLeft: "5px" }}>{divText} </div></div>
            : null;
    }
    private deleteFileEntry = async (pos) => {

        const isOk = await DialogHelper.confirm(Config.translations.delete);
        if (isOk) {
            HTTPService.post<JsonResultClass>("ServerJob/DeleteDocument", { jobid: this.props.entity.Jobid, pos: pos }).then(result => {
                if (result.Code == 0) {
                    this.updateFileGrid();
                    NotificationHelper.showSuccessMessage(result.Message);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
        }
    }
    private updateFileGrid = () => {
        HTTPService.get<JsonResultClass>("ServerJob/UpdateFileGridData?id=" + this.props.entity.Jobid).then(result => {          
            let copyEntity = JSON.parse(JSON.stringify(this.props.entity));
            copyEntity.FileNames = result.Data;
            Helper.updateEntity(this.props.entity, copyEntity);
            this.props.onChange({ model: "entity.FileNames" }, this.props.entity.FileNames);
            this.setState({ fileGridData: result.Data });
        });
        
    }
    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem) => {
        if (type == ToolBarStandardButtonType.DELETE) {
            this.deleteFileEntry(dataItem.Pos);
        }

    }
    onSelectionChanged = (dataItem) => {
        if (Helper.hasValue(dataItem))
            this.setState({ deleteEnable: (!dataItem.Deleted && !this.props.entity.IsInExecution) });
    }
   
    private renderFileGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.deleteEnable });

        let grid = (
            <Grid data={this.state.fileGridData} options={this.fileGridOptions} id="filegrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}
                onSelectionChanged={this.onSelectionChanged}
            />
        );
        return (grid)
    }
    render() {
        return (<>
            {this.renderDialog()}
            <div style={{ maxWidth: 400 }}>
                <div id="document-upload" style={{ marginTop: "20px" }}><label>{this.translations["WebSMS.DataExchangeModule.File.UploadFile"]}: <input name='updateFile' type='file' ref={r => this._uploadInputRef = r} /></label></div>
            </div>
            {this.renderFileGrid()}
        </>
        );
    }
};
interface FileNodeElement {
    text?: string;
    expanded?: boolean;
    id: string;
    items?: Array<FileNodeElement>;


}